import styled from "styled-components";

const Tag = styled.span`
  background: ${props =>
    props.type === "Resolución de la Corte IDH"
      ? "#d9534f"
      : props.type === "Resolución de Presidencia Corte"
        ? "#6f46b8"
        : props.type === "Document"
          ? "#6866cc"
          : props.type === "Victim"
            ? "#c03b22"
            : props.type === "Testimonial"
              ? "#d9534f"
              : props.primary || props.type === "primary"
                ? "#007bff"
                : props.secondary
                  ? "#6c757d"
                  : props.success || props.type === "success"
                    ? "#28a745"
                    : props.danger || props.type === "danger"
                      ? "#dc3545"
                      : props.warning || props.type === "warning"
                        ? "#ffc107"
                        : props.info
                          ? "#17a2b8"
                          : props.light
                            ? "#fff"
                            : props.dark
                              ? "#343a40"
                              : props.disabled
                                ? "rgba(0,0,0,.1)"
                                : props.type
                                  ? props.type
                                  : "#6c757d"};
  border: 1px solid rgba(0, 0, 0, 0.05);
  color: ${props =>
    props.light ? "#212529" : props.disabled ? "#777" : "#fff"};
  display: inline-block;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: none;
`;

export default Tag;



// WEBPACK FOOTER //
// ./src/UI/Tag/Tag.js